/**
 * Lightweight notification utility  - dispatches custom events
 * picked up by the global AppNotification listener in Layout.jsx.
 * Use this instead of native alert() or importing react-toastify everywhere.
 */
export function notifyError(message) {
  window.dispatchEvent(new CustomEvent('app-notify', { detail: { type: 'error', message } }));
}

export function notifySuccess(message) {
  window.dispatchEvent(new CustomEvent('app-notify', { detail: { type: 'success', message } }));
}
